import React, { Component } from "react";
import "./Client.css";

const Image = ({ client, picturesPath }) => {
  return <img className="avatar" src={picturesPath + client.foto} alt="" />;
};

const Info = ({ client }) => {
  const status = client.situacao === "A" ? true : false;
  return (
    <div className="info">
      <div className="name">{client.nome}</div>
      <div className={"status " + (status ? "online" : "")}>
        {status ? "Online" : "Offline"}
      </div>
    </div>
  );
};

export default class Client extends Component {
  render() {
    return (
      <div id="client">
        <Image client={this.props.client} picturesPath={this.props.picturesPath} />
        <Info client={this.props.client} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/options/Client.js